import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useSiteConfig } from "@/hooks/useSiteConfig";
import { Reveal, SectionHeader } from "./primitives";

const Faq = () => {
  const config = useSiteConfig();
  return (
    <section id="faq" className="relative py-24 lg:py-36 border-t border-line" data-testid="faq-section">
      <div className="section-shell grid gap-12 lg:grid-cols-[1fr_1.5fr] lg:gap-20 items-start">
        <SectionHeader
          index={17}
          eyebrow="FAQ"
          title={<>Questions,<br />Answered.</>}
          sub="Straight answers about JCV — its supply, its chain, its plans and its limits."
          testId="faq-header"
        />
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {config.faq.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="card-surface rounded-lg border-line px-6 data-[state=open]:border-teal/50"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-display font-semibold text-sm sm:text-base text-mist hover:text-teal hover:no-underline py-5" data-testid={`faq-trigger-${i}`}>
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-slate leading-relaxed pb-5" data-testid={`faq-content-${i}`}>
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default Faq;
